import { render, staticRenderFns } from "./c_app.vue?vue&type=template&id=23e2dda2&"
import script from "./c_app.vue?vue&type=script&lang=js&"
export * from "./c_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports